module.exports = __webpack_public_path__ + "static/media/modalImg1.9513a953.png";